import React from 'react';

interface AppNavProps {
  onNavigateToHome: () => void;
  onNavigateToDictionary: () => void;
  onNavigateToApp: () => void;
  onStartAiInterpretation: () => void;
}

const preventDefault = (e: React.MouseEvent, handler: () => void) => {
  if (!(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) {
    e.preventDefault();
    handler();
  }
};

const AppNav: React.FC<AppNavProps> = ({
  onNavigateToHome,
  onNavigateToDictionary,
  onNavigateToApp,
  onStartAiInterpretation
}) => {
  const linkBase = 'no-underline whitespace-nowrap text-[13px] sm:text-sm font-semibold px-2.5 py-2 rounded-xl transition-colors';

  return (
    <header className="sticky top-0 z-30 w-full bg-slate-900/85 backdrop-blur-md border-b border-slate-700/70" dir="rtl">
      <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center justify-between gap-3">
        <a
          href="/"
          onClick={(e) => preventDefault(e, onNavigateToHome)}
          className="flex items-center gap-2 no-underline shrink-0"
          aria-label="ابن سيرين - الرئيسية"
        >
          <img src="/nav-icon.svg" alt="" width="28" height="28" className="w-7 h-7" />
          <span className="font-extrabold text-white text-sm sm:text-base">ابن سيرين</span>
        </a>

        <nav aria-label="التنقل الرئيسي" className="flex items-center gap-0.5 overflow-x-auto">
          <a
            href="/"
            onClick={(e) => preventDefault(e, onNavigateToHome)}
            className={`${linkBase} text-slate-300 hover:text-emerald-300`}
          >
            الرئيسية
          </a>
          <a
            href="/?ai=1"
            onClick={(e) => preventDefault(e, onStartAiInterpretation)}
            className={`${linkBase} text-emerald-400 hover:text-emerald-300`}
          >
            ✨ تفسير حلمي بالـAI
          </a>
          <a
            href="/dictionary"
            onClick={(e) => preventDefault(e, onNavigateToDictionary)}
            className={`${linkBase} text-slate-300 hover:text-emerald-300`}
          >
            📖 قاموس الأحلام
          </a>
          <a
            href="/dictionary"
            onClick={(e) => preventDefault(e, onNavigateToDictionary)}
            className={`${linkBase} hidden md:flex text-slate-300 hover:text-emerald-300`}
          >
            🔤 فهرس الحروف
          </a>
          <a
            href="/dictionary"
            onClick={(e) => preventDefault(e, onNavigateToDictionary)}
            className={`${linkBase} hidden md:flex text-slate-300 hover:text-emerald-300`}
          >
            🧩 التصنيفات
          </a>
          <a
            href="/app"
            onClick={(e) => preventDefault(e, onNavigateToApp)}
            className={`${linkBase} bg-emerald-600/15 border border-emerald-500/30 text-emerald-300 hover:bg-emerald-600/25`}
          >
            📱 التطبيق
          </a>
        </nav>
      </div>
    </header>
  );
};

export default AppNav;